import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "page-header__user-info" };
const _hoisted_2 = { class: "page-header__user-info-nav" };
const _hoisted_3 = {
    key: 0,
    class: "page-header__user-info-nav-item page-header__user-info-nav-item--info"
};
const _hoisted_4 = {
    key: 1,
    class: "page-header__user-info-nav-item page-header__user-info-nav-item--config"
};
const _hoisted_5 = {
    key: 2,
    class: "page-header__user-info-nav-item page-header__user-info-nav-item--user"
};
const _hoisted_6 = {
    key: 0,
    class: "page-header__user-info-nav-item"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = { class: "locale" };
const _hoisted_9 = { class: "page-header__user-info-nav-item page-header__user-info-nav-item--user" };
import { ref } from 'vue';
import AppDropdown from "@astina/paloma-common-ui/src/components/AppDropdown.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import env from '../services/AppEnv';
import config from '../services/PortalConfig';
import CustomerButton from "./CustomerButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppUserInfo',
    setup(__props) {
        const user = ref(env.user);
        const locale = ref(env.locale);
        const locales = ref(env.translations.locales);
        const infoComponent = ref(config.headerInfoComponent);
        function langUrl(localeParam) {
            const current = window.location.href.replace(/([?&])_lang=[a-z_]{2,5}/, '');
            return current + (current.indexOf('?') === -1 ? '?' : '&') + '_lang=' + localeParam;
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("nav", _hoisted_2, [
                    (infoComponent.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(AppDropdown, {
                                "button-style": "link",
                                position: "left"
                            }, {
                                button: _withCtx(() => [
                                    _createVNode(Icon, { name: "info-circle" })
                                ]),
                                menu: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(infoComponent.value)))
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    (_ctx.$isGranted('PORTAL_USERS_MANAGE', 'PORTAL_NOTIFICATIONS_MANAGE', 'PORTAL_INTEGRATIONS_MANAGE', 'PORTAL_ORDERS_CREATE'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(AppDropdown, {
                                "button-style": "link",
                                position: "left"
                            }, {
                                button: _withCtx(() => [
                                    _createVNode(Icon, { name: "config" })
                                ]),
                                menu: _withCtx(() => [
                                    (_ctx.$isGranted('PORTAL_USERS_MANAGE'))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 0,
                                            to: { name: 'config_users' },
                                            class: "dropdown__item"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(Icon, { name: "users" }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.config_users')), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    (_ctx.$isGranted('PORTAL_NOTIFICATIONS_MANAGE'))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 1,
                                            to: { name: 'config_notifications' },
                                            class: "dropdown__item"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(Icon, { name: "bell" }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.config_notifications')), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    (_ctx.$isGranted('PORTAL_INTEGRATIONS_MANAGE'))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 2,
                                            to: { name: 'integration' },
                                            class: "dropdown__item"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(Icon, { name: "exchange" }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.integration')), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    _cache[3] || (_cache[3] = _createTextVNode()),
                                    (_ctx.$isGranted('PORTAL_ORDERS_CREATE'))
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: 3,
                                            to: { name: 'catalog_bulk_search' },
                                            class: "dropdown__item"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(Icon, { name: "bullhorn" }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.catalog_bulk_search')), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    (user.value.authenticated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(CustomerButton)
                        ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (locales.value.length > 1 || locale.value !== locales.value[0])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode(AppDropdown, {
                                        "button-style": "link",
                                        position: "left"
                                    }, {
                                        button: _withCtx(() => [
                                            _createVNode(Icon, { name: "globe" })
                                        ]),
                                        menu: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locales.value, (loc) => {
                                                return (_openBlock(), _createElementBlock("a", {
                                                    href: langUrl(loc),
                                                    key: loc,
                                                    class: _normalizeClass([{ 'locale--active': loc === locale.value }, "dropdown__item"])
                                                }, [
                                                    _createElementVNode("span", _hoisted_8, _toDisplayString(loc), 1)
                                                ], 10, _hoisted_7));
                                            }), 128))
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_router_link, {
                                    to: { name: 'login' },
                                    class: "button button--link login-button"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(Icon, { name: "login" })
                                    ]),
                                    _: 1
                                })
                            ])
                        ], 64))
                ])
            ]));
        };
    }
});
